var App = App || {};

App.TestimonialSlider = (function ($) {
    'use strict';

    var $slider;

    function init() {
        $slider = $('.testimonial-slide-carousel__container');

        $slider.each(function (event, slick, currentSlide, nextSlide) {
            $(this).slick({
                dots: false,
                arrows: true,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous testimonial Slide" tabindex="0" role="button"><span class="sr-only">Scroll to view previous testimonial</span><i class="fa-light fa-angle-left"></i></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next testimonial Slide" tabindex="0" role="button"><span class="sr-only">Scroll to view next testimonial</span><i class="fa-light fa-angle-right"></i></button>',
                appendArrows: $(".testimonial-controls"),
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 7000,
                accessibility: true,
                adaptiveHeight: false,
                infinite: true
            });
        });

        $slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $("[data-slick-index='" + currentSlide + "']").attr("aria-live", "assertive");
            $("[data-slick-index='" + currentSlide + "']").siblings(".slick-slide").attr("aria-live", "polite");
        });

        $(".testimonial-slider-item__content p").each(function () {
            if ($(this).text().length > 300) {
                $(this).text(function (index, currentText) {
                    var newText = currentText.substr(0, 300);
                    return newText;
                });
                $(this).append("...");
            }
        });

        $(".testimonial-controls").each(function () {
            $(this).find("button").eq(0).after($(".slick-controls").clone());
        });

        $(document).on("click", ".slick-control", function () {
            var slider = $(this).parents('section.testimonial-slider').find('.testimonial-slide-carousel__container');
            if (slider.length > 0) {
                slider.slick($(this).data("action"));
                $(".slick-control").show();
                $(this).hide();
            }
        });

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.TestimonialSlider.init();
});
